<div class="cols">
    <div class="copy">
        <div class="inner">
            <div class="loadingPage">
                <img src="../../../assets/images/takeda_logo.png" alt="Takeda" class="logo">
                <div class="loader-spinner"></div>
            </div>
        </div>
    </div>
</div>